import { Box, FlexBox, H5, InlineText } from '@helloself/hello-self-ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { BaseTileProps } from '../../../model/types';
import { EmptyTilePlaceholder } from '../../EmptyTilePlaceholder';
import Tile from '../../Tile';

export type AboutMeTileProps = BaseTileProps & {
    aboutMe?: string;
};

export function AboutMeTile({ aboutMe, isLoading, isOwnProfile }: AboutMeTileProps) {
    if (isLoading) {
        return (
            <Tile>
                <Box data-testid="AboutMeTile">
                    <H5 margin={'0 0 24px'}>About me</H5>
                    <FlexBox flexDirection="column" gap="8px">
                        <Skeleton width="480px" height="24px" />
                        <Skeleton width="460px" height="24px" />
                        <Skeleton width="420px" height="24px" />
                    </FlexBox>
                </Box>
            </Tile>
        );
    }

    if (!aboutMe || aboutMe.trim().length === 0) {
        return (
            <Tile>
                <Box data-testid="AboutMeTile">
                    <H5 margin={'0 0 24px'}>About me</H5>
                    <EmptyTilePlaceholder isOwnProfile={isOwnProfile} />
                </Box>
            </Tile>
        );
    }

    return (
        <Tile>
            <Box data-testid="AboutMeTile">
                <H5 margin={'0 0 24px'}>About me</H5>
                <InlineText fontSize="16px" whiteSpace="pre-line">
                    {aboutMe}
                </InlineText>
            </Box>
        </Tile>
    );
}
